import { render, staticRenderFns } from "./MemberComp.vue?vue&type=template&id=5b91fa8e"
import script from "./MemberComp.vue?vue&type=script&lang=js"
export * from "./MemberComp.vue?vue&type=script&lang=js"
import style0 from "./MemberComp.vue?vue&type=style&index=0&id=5b91fa8e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports